import React, { useEffect, useRef, useState } from "react";
import { useLocation, Link, useHistory } from "react-router-dom";
import queryString from "query-string";
import { useAuth,authFetch } from "../../auth";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import XLSX from "xlsx";
import {
  faHome,
  faEllipsisH,
  faSearch,
  faEdit,
  faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import {
  Button,
  ButtonGroup,
  Breadcrumb,
  Col,
  Dropdown,
  Container,
  Card,
  Table,
  Modal,
  CloseButton,
  Form,
  InputGroup,
} from "@themesberg/react-bootstrap";
import { Routes } from "../../routes";
import { FormattedMessage } from "react-intl";
import {
  CompanyEditModal,
  CompanyDeleteModal,
  CompanyCreateModal,
} from "../../components/Modal";
import { Load,ExeclUploadSuccess } from "../../components/Modal";
import "./scrollbar.css";

const TableRow = ({ item,number }) => {
  const {
    id,
    Name,
    RegistrationID,
    PrincipalName,
    industry,
    establish,
    country,
    regiDate,
    content,
  } = item;

  //const country_name = country === 2 ? "Russia" : "Korea";
  var country_name = "Korea";

  if(country == 1)
  {
    country_name = "Korea";
  } else if(country == 2)
  {
    country_name = "Russia";
  } else if(country == 3)
  {
    country_name = "Oʻzbekiston";
  } else if(country == 4)
  {
    country_name = "Kyrgyzstan";
  } else if(country == 5)
  {
    country_name = "Kazakhstan";
  } else if(country == 6)
  {
    country_name = "Ukraine";
  } else if(country == 7)
  {
    country_name = "Belarus";
  }

  const [edit, setEdit] = useState(false);
  const [delControl, setDelControl] = useState({
    delShow: false,
    delId: "",
  });
  const { delShow, delId } = delControl;

  const onDelete = () => {
    authFetch(process.env.REACT_APP_API_URL + `/api/admin/company/${RegistrationID}`, {
      method: "DELETE",
    }).then((resp) => {
      if (resp.status === 200) {
        setDelControl({
          delShow: true,
          delId: "compDeleteSuccess",
        });
      } else if (resp.status === 401) {
        setDelControl({
          delShow: true,
          delId: "compDeleteFail",
        });
      }
    });
  };

  return (
    <tr>
      <td>{number}</td>
      <td style={{ whiteSpace: "normal" }}>
        <span className="fw-normal">
          <Link
            to={
              Routes.CompInfo.path +
              "?index=company" +
              RegistrationID +
              "&id=" +
              id + ".0"
            }
            target="_blank"
            rel="noopener noreferrer"
            style={{
              textDecoration: "underline",
            }}
          >
            {Name}
          </Link>
        </span>
      </td>
      <td>
        <span className="fw-normal">{country_name}</span>
      </td>
      {edit && (
        <CompanyEditModal
          comp={item}
          onCancel={() => {
            setEdit((prev) => !prev);
          }}
        />
      )}
      <td style={{ whiteSpace: "normal" }}>
        <span className="fw-normal">{PrincipalName}</span>
      </td>

      <td>
        <span className="fw-normal">{establish}</span>
      </td>
      <td style={{ whiteSpace: "normal" }}>
        <span className="fw-normal">{industry}</span>
      </td>
      <td>
        <span className="fw-normal">{regiDate}</span>
      </td>
      {delShow && <CompanyDeleteModal id={delId} />}
      <td>
        <Dropdown as={ButtonGroup}>
          <Dropdown.Toggle
            as={Button}
            split
            variant="link"
            className="text-dark m-0 p-0"
          >
            <span className="icon icon-sm">
              <FontAwesomeIcon icon={faEllipsisH} className="icon-dark" />
            </span>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                setEdit(true);
              }}
            >
              <FontAwesomeIcon icon={faEdit} className="me-2" />
              <FormattedMessage id="toEdit" />
            </Dropdown.Item>
            <Dropdown.Item onClick={onDelete} className="text-danger">
              <FontAwesomeIcon icon={faTrashAlt} className="me-2" />
              <FormattedMessage id="toDelete" />
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </td>
    </tr>
  );
};

const TransactionsTable = ({ transactions }) => {
  const totalTransactions = transactions.length;
  var transaction_num = 1;
  const scrollContainerStyle = { width: "800px", maxHeight: "400px" };

  return (
    <div className="scrollbar scrollbar-primary  mt-5 mx-auto">
      <Card border="light" className="table-wrapper table-responsive shadow-sm" >
        <Card.Body className="pt-0">
          <Table hover className="user-table align-items-center">
            <thead>
              <tr>
                <th className="border-bottom">#</th>
                <th className="border-bottom">Name</th>
                <th className="border-bottom">Country</th>
                <th className="border-bottom">PrincipalName</th>
                <th className="border-bottom">establish</th>
                <th className="border-bottom">industry</th>
                <th className="border-bottom">Registration Date</th>
                <th className="border-bottom"></th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((user) => (
                <TableRow key={user.id} item={user} number={transaction_num++} />
              ))}
            </tbody>
          </Table>

          <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-between">
            <small className="fw-bold">
              Showing <b>{totalTransactions}</b> out of <b>{totalTransactions}</b>{" "}
              entries
            </small>
          </Card.Footer>
        </Card.Body>
      </Card>
    </div>
    
  );
};

export default () => {

  const [compList, setCompList] = useState([]);
  const [load, setLoad] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [createControl, setCreateControl] = useState({
    createShow: false,
    createId: "",
  });
  const location = useLocation();
  const history = useHistory();

  const [input, setInput] = useState({
    searchText: "",
    searchInfo: "0",
  });

  const { searchText, searchInfo } = input;

  const query = queryString.parse(location.search);

  //const searchInfo = query.searchInfo;
  //const searchText = query.searchText;

  const [excel, setExeclUploadSuccess] = useState(false);

  const hiddenFileInput = useRef(null);
  const { createShow, createId } = createControl;

  const onButtonSearch = () => {
    //var querySearch_Info = "/admin/search/?searchInfo=" + searchInfo + "&searchText=" + searchText;
    authFetch(process.env.REACT_APP_API_URL + "/api/admin/search", {
      method: "post",
      body: JSON.stringify({
        searchInfo,
        searchText,
      }),
    })
    .then((resp) => resp.json())
    .then((resp) => {
      setCompList(resp);
    }); 
  };

  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  useEffect(() => {
    if (searchInfo != undefined && searchText != "") {

      authFetch(process.env.REACT_APP_API_URL + "/api/admin/search", {
        method: "post",
        body: JSON.stringify({
          searchInfo,
          searchText,
        }),
      })
      .then((resp) => resp.json())
      .then((resp) => {
        setCompList(resp);
      }); 
    }
    else
    {
      authFetch(process.env.REACT_APP_API_URL + "/api/admin/company")
      .then((resp) => resp.json())
      .then((resp) => {
        setCompList(resp);
      });
    }
  }, []);

  const onChange = (e) => {
    const { name, value } = e.target;
    setInput((prev) => ({ ...prev, [name]: value }));
  };

  const onDeleteClick = (e) => {
    fetch(process.env.REACT_APP_API_URL + "/api/admin/delete-all", {
      method: "DELETE",
    })
      .then((resp) => resp.json())
      .then((resp) => {
        console.log(resp);
      });
  };

  const onExcelUpload = (e) => {
    let reader = new FileReader();
    let sheetArr = [];

    reader.onloadend = () => {
      const fileData = reader.result;
      const excel = XLSX.read(fileData, { type: "binary", cellDates: true });
      excel.SheetNames.forEach((sheetName) => {
        const rowObj = XLSX.utils.sheet_to_json(excel.Sheets[sheetName]);
        sheetArr.push(rowObj);
      });
      const adminID = localStorage.getItem('accessID');

      console.log(JSON.stringify({ sheetArr,
        "adminID":adminID
       }));

      //setLoad(true);
      setExeclUploadSuccess(true);
      setDisabled(true);

      authFetch(process.env.REACT_APP_API_URL + "/api/admin/company", {
        method: "POST",
        body: JSON.stringify({ sheetArr,
          "adminID":adminID
         }),
      })
        .then((resp) => {
          resp.json()
          setDisabled(false);
          //window.location.reload();
        });
    };

    reader.readAsBinaryString(e.target.files[0]);
  };

  return (
    <Container fluid>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item>Admin</Breadcrumb.Item>
            <Breadcrumb.Item active>Managing Companies</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Companies</h4>
          <p className="mb-0">Your web analytics dashboard template.</p>
        </div>
        {createShow && (
          <CompanyCreateModal
            onCancel={() => {
              setCreateControl((prev)  => ({
                ...prev,
                createShow: false,
              }));
            }}
          />
        )}
        <Col lg={1}>
          <Form.Select
            aria-label="Default select example"
            name="searchInfo"
            value={searchInfo}
            onChange={onChange}
          >
            <FormattedMessage id="companyNm">
              {(message) => <option value="0">{message}</option>}
            </FormattedMessage>
            <FormattedMessage id="principal">
              {(message) => <option value="1">{message}</option>}
            </FormattedMessage>
            <FormattedMessage id="business">
              {(message) => <option value="2">{message}</option>}
            </FormattedMessage>
          </Form.Select>
        </Col>
        <div className="d-flex align-items-center">
          <Form className="navbar-search">
            <Form.Group id="topbarSearch">
              <InputGroup className="input-group-merge search-bar">
                <InputGroup.Text>
                  <FontAwesomeIcon icon={faSearch} />
                </InputGroup.Text>
                <Form.Control type="text" placeholder="Search" name="searchText" value={searchText} onChange={onChange} />
              </InputGroup>
            </Form.Group>
          </Form>
        </div>
        <Col lg={1} className="p-0">
          <Button onClick={onButtonSearch} type="button" className="w-75">
            <FormattedMessage id="search" />
          </Button>
        </Col>
        <div className="btn-toolbar mb-2 mb-md-0">
          <Button onClick={handleClick}>Upload a file</Button>
          <input
            type="file"
            id="file-upload"
            accept=".xlsx, .xls"
            ref={hiddenFileInput}
            style={{ display: "none" }}
            onChange={onExcelUpload}
          />
          <Button
            onClick={() => {
              setCreateControl((prev) => ({ ...prev, createShow: true }));
            }}
          >
            Create Company
          </Button>
          <Button onClick={onDeleteClick}>Delete All</Button>
        </div>
      </div>
      {excel && <ExeclUploadSuccess disabled={disabled} />}
      <TransactionsTable transactions={compList} />
    </Container>
  );
};
